import { Toast } from "primereact/toast";
import "primereact/resources/themes/saga-orange/theme.css";
import "primeicons/primeicons.css";
import "../../../node_modules/primeflex/primeflex.css";
import functionListStyles from "../../container/Function-setup/functionList.module.scss";
import { useEffect, useMemo, useRef, useState, useContext } from "react";
import Spinner from "../../components/spinner/spinner";
import { Form, Formik } from "formik";
import { ConfirmDialog } from "primereact/confirmdialog";
import styles from "./SevenElevenOrder.module.scss";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import * as constants from "../../constants/constants";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as Yup from "yup";
import {
  sevenElevenOrderColumns,
  sevenElevenOrderLineItemColumns
} from "../../constants/table-columns/tableColumns";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../store/action-creators";
import LoginUserDataContext from "../../store/login";
import { appInsights } from "../../AppInsights";
import { Dialog } from "primereact/dialog";
import { sortData } from "../../constants/dataSort";
import { useFormik } from "formik";
import { Tag } from "primereact/tag";
import { getRegionsandTradingPartnerListForWebsiteOrders, getSevenElevenOrderDetails, proceedSevenElevenSucessItems, reProcessSevenElevenOrders } from "../../services/logSummary";
import { getOrderConfigTradingPartnerDetails } from "../../services/OrderConfigService";

export default function SevenElevenOrder() {
  const toast = useRef(null);
  const [disableFields, setDisableFields] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageRows, setCurrentPageRows] = useState(10);
  const [sevenElevenOrders, setSevenElevenOrders] = useState([]);
  const [selectedSevenElevenOrders, setSelectedSevenElevenOrders] = useState([]);
  const [allExpanded, setAllExpanded] = useState(false);
  const [tradingPartners, setTradingPartners] = useState([]);
  const [expandedRows, setExpandedRows] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [totalNumberOfFiles, setTotalNumberOfFiles] = useState(0);
  const [failedItemsCount, setFailedItemsCount] = useState(0);
  const [showReProcessConfirmation, setShowReprocesConfirmation] = useState(false);
  const [defaultRegion, setDefaultRegion] = useState([]);
  const [proceedWithSuccessConfirmation, setProceedWithSuccessConfirmation] = useState(false);
  const [proceedSalesOrderIds, setProceedSalesOrderIds] = useState([]);

  appInsights.trackPageView({
    name: "7Eleven screen visited"
  });
  const [userData, setUserData] = useContext(LoginUserDataContext);
  const [regions, setRegions] = useState([]);

  const fetchRegionsandTradingPartnerListForSevenEleven = async () => {
    setShowSpinner(true);
    try {
      let result = await getRegionsandTradingPartnerListForWebsiteOrders();
      if (!result) return;
      setRegions(result);
    }
    catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo: "Exception while fetching regions for  7Eleven screen"
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
    finally {
      setShowSpinner(false);
    }
  }

  useEffect(() => {
    fetchRegionsandTradingPartnerListForSevenEleven();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (regions.length == 0) return;
    if (userData?.regionId != null) {
      let filteredRegion = regions?.filter(
        (item) => item?.region?.toLocaleLowerCase() === userData?.regionName?.toLocaleLowerCase()
      );
      formik.setFieldValue("region", filteredRegion[0] ? filteredRegion[0]?.region : regions[0]?.region);
      let selectedRegion =
        regions.find(
          (item) =>
            item?.region?.toLowerCase() ===
            filteredRegion[0]?.region?.toLowerCase()
        ) || regions[0];
      setTradingPartners(selectedRegion?.tradingPartnerList ?? []);
      setDefaultRegion(filteredRegion[0]?.region);
      fetchSevenElevenOrders({ ...initialValues, region: filteredRegion[0] ? filteredRegion[0]?.region : regions[0]?.region });
    } else {
      formik.setFieldValue("region", regions[0]?.region);
      setTradingPartners(regions[0]?.tradingPartnerList);
      fetchSevenElevenOrders({ ...initialValues, region: regions[0]?.region });
    }
  }, [regions]);

  const initialValues = useMemo(
    () => ({
      region: regions?.length > 0 ? regions[0]?.region : null,
      tradingPartnerName: null,
      orderDateFrom: new Date(),
      orderDateTo: new Date()
    }),
    []
  );

  const validationSchema = Yup.object().shape({
    orderDateFrom: Yup.date()
      .nullable()
      .required("Start date is required")
      .typeError("Invalid start date"),

    orderDateTo: Yup.date()
      .nullable()
      .required("End date is required")
      .typeError("Invalid end date"),
    region: Yup.string()
      .required("Region is required")
      .test("region-has-name", "Region is required", function (value) {
        return !!value;
      }),
    tradingPartnerName: Yup.mixed().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      fetchSevenElevenOrders(values);
      setCurrentPage(0);
      setCurrentPageRows(10);
      setShowSpinner(true);
    },
    validateOnChange: true,
    validateOnBlur: true,
  });

  const formRef = useRef(formik);

  const reProcessLineItemDataBtn = (rowData) => {
    return (<>
      {rowData?.isFileEligibleForReprocess && (
        <Button
          label="ReProcess"
          icon="pi pi-replay"
          className={`${functionListStyles.reprocessBtn}`}
          onClick={() => {
            onReProcessAllHandler([rowData?.salesOrderId], 0);
          }}
        />
      )}
    </>);
  }

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-1 pl-5 ml-5" style={{ background: "white" }}>
        {data?.failedUniqueItemIds && (<p className="m-0 p-0 pb-1 p-error"><strong>Failed unique items information:<span className="pl-1">{data?.failedUniqueItemIds.replaceAll(",", ", ")}</span></strong></p>)}
        <DataTable
          value={data?.salesOrders}
          rows={constants.defaultRows}
          rowsPerPageOptions={constants.rowsPerPageOptions}
          paginator={constants.paginator}
          scrollable={constants.scrollable}
        >
          {sevenElevenOrderLineItemColumns.map((col, index) => (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              sortable={col.sort}
              style={{ minWidth: col.minWidth }}
              headerStyle={{ minWidth: col.minWidth }}
              body={
                col?.field?.toLocaleLowerCase() === "d365status"
                  ? d365StatusFormat
                  : col?.field?.toLocaleLowerCase() === "action"
                    ? reProcessLineItemDataBtn
                    : col?.field?.toLocaleLowerCase() === "d365message"
                      ? errorBodyTemplate
                      : col?.value || null
              }
            />
          ))}
        </DataTable>

      </div>
    );
  };

  const toggleRows = () => {
    if (allExpanded) {
      setExpandedRows(null);
      setAllExpanded(false);
    } else {
      let newExpandedRows = {};
      sevenElevenOrders.forEach((p) => (newExpandedRows[`${p?.fileCorrelationId}`] = true));
      setExpandedRows(newExpandedRows);
      setAllExpanded(true);
    }
  };

  const d365StatusFormat = (rowData) => {
    let severityValue = "";
    if (rowData?.d365Status == null) return;
    switch (rowData.d365Status) {
      case constants.emailOrdersD365StatusOptions.Enqueued:
        severityValue = "secondary";
        break;
      case constants.emailOrdersD365StatusOptions.InProcess:
        severityValue = "info";
        break;
      case constants.emailOrdersD365StatusOptions.ProcessedWithErrors:
        severityValue = "danger";
        break;
      case constants.emailOrdersD365StatusOptions.Processed:
        severityValue = "success";
        break;
      default:
        severityValue = "warning";
        break;
    }
    if (rowData?.d365Status == null) return;
    return (
      <div>
        <Tag severity={severityValue} value={rowData?.d365Status} rounded></Tag>
      </div>
    );
  };

  const errorBodyTemplate = (rowData) => {
    return rowData?.d365Message;
  };

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("-");
  }

  const fetchSevenElevenOrders = async (formbody) => {
    try {
      setShowSpinner(true);
      let formData = {};
      formData = {
        region: formbody?.region
          ? formbody?.region
          : null,
        startDate: formbody?.orderDateFrom
          ? formatDate(formbody?.orderDateFrom)
          : null,
        endDate: formbody?.orderDateTo ? formatDate(formbody?.orderDateTo) : null,
        tradingPartner: formbody?.tradingPartnerName
          ? formbody?.tradingPartnerName
          : null,
      };
      let result = await getSevenElevenOrderDetails(formData);
      setSevenElevenOrders(result);
    } catch (error) {
      setShowSpinner(false);
      if (error?.message !== "No records found") {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: error.message,
          life: 4000
        });
      }
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo: "Exception while submitting 7Eleven screen"
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
    finally {
      setShowSpinner(false);
    }
  }

  const orderActionTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-refresh"
          rounded
          text
          raised
          severity="secondary"
          aria-label="Reprocess All"
          disabled={rowData?.isAllProcessed}
          onClick={() => onReProcessAllHandler((rowData?.salesOrders || [])?.filter((x) => x?.isFileEligibleForReprocess === true).map((x) => x?.salesOrderId), (rowData?.d365FailedPOs ?? 0) + (rowData?.invalidPOs ?? 0), rowData?.actualPOs)}
          tooltip="Reprocess All - It reprocesses the failed orders due to errors in D365."
        />
          <Button
           icon="pi pi-forward"
           rounded
           text
           raised
           severity="secondary"
           aria-label="Proceed All"
           disabled={rowData?.failedUniqueItemIds == null || rowData?.failedUniqueItemIds?.length === 0}
           onClick={() => onProceedAllSucceedHandler(rowData)}
           tooltip="Proceed All - It will skip the error line items and continue processing all the remaining successful records."
           />
      </div>
    );
  };

  const onReProcessAllHandler = (rowData, failedRecordsCount, successRecordsCount) => {
    setSelectedRecord(rowData);
    setFailedItemsCount(failedRecordsCount ? failedRecordsCount : 0);
    setTotalNumberOfFiles(successRecordsCount ? successRecordsCount : 0);
    setShowReprocesConfirmation(true);
  };

  const reprocessItems = async () => {
    try {
      setShowSpinner(true);
      let result = await reProcessSevenElevenOrders(selectedRecord, formik.values.region);
      if (!!result) {
        await fetchSevenElevenOrders(formik?.values);
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: result,
          life: 4000
        });
      }
      setShowSpinner(false);
    } catch (error) {
      setShowReprocesConfirmation(false);
      await fetchSevenElevenOrders(formik?.values);
      setShowSpinner(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        life: 4000
      });
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo: "Exception while Reprocess all 7Eleven API"
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
  };
   const onProceedAllSucceedHandler = async(rowData)=>{
    setProceedWithSuccessConfirmation(true);
    setProceedSalesOrderIds((rowData?.salesOrders || []).map(o => o.salesOrderId));
  }
    const proceedWithSuccessItems = async()=>{
      try{
        setShowSpinner(true);
        const result = await proceedSevenElevenSucessItems(proceedSalesOrderIds, formik.values.region);
        if (!!result) {
        await fetchSevenElevenOrders(formik?.values);
        toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Proceed with successful records is completed.",
          life: 5000
        });
      }
      setShowSpinner(false);
      } catch(error){
        setProceedWithSuccessConfirmation(false);
        setShowSpinner(false);
        toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message,
        life: 4000
      });
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo: "Exception while Proceed all 7Eleven API"
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
  }

  return (
    <>
      {showSpinner && <Spinner />}
      <div className="grid pt-2">
        <div className="col-12 ">
          <form onSubmit={formik.handleSubmit} ref={formRef}>
            <div className="grid p-fluid">
              <div className="col-12 md:col-2">
                <div className={styles?.formLabelContainer}>
                  <label htmlFor="region" style={{ marginBottom: "0.5rem", display: "block" }}>
                    <span className={styles?.formLabel}>Region</span>
                  </label>
                </div>
                <Dropdown
                  id="region"
                  name="region"
                  optionLabel="region"
                  optionValue="region"
                  placeholder="Region"
                  value={formik.values.region}
                  onChange={async (e) => {
                    formik.setFieldTouched("region", true);
                    formik.setFieldValue("region", e?.value)
                    formik.setFieldValue("tradingPartnerName", null);
                    const selectedRegion = regions.find((x) => x?.region === e?.value);
                    if (selectedRegion) {
                      setTradingPartners(selectedRegion?.tradingPartnerList);
                    } else {
                      setTradingPartners([]);
                    }
                  }}
                  options={regions}
                  filter
                  className={`${styles.dropdown} ${styles.formControl}`}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.region && formik.errors.region && (
                  <small className="p-error">{formik.errors.region}</small>
                )}
              </div>

              <div className="col-12 md:col-2">
                <div className={styles?.formLabelContainer}>
                  <label htmlFor="tradingPartnerName" style={{ marginBottom: "0.5rem", display: "block" }}>
                    <span className={styles?.formLabel}>Trading Partner</span>
                  </label>
                </div>
                <Dropdown
                  id="tradingPartnerName"
                  name="tradingPartnerName"
                  placeholder="Trading Partner"
                  value={formik.values.tradingPartnerName}
                  onChange={async (e) => {
                    formik.setFieldValue("tradingPartnerName", e?.value);
                  }}
                  options={tradingPartners}
                  filter
                  showClear
                  className={`${styles.dropdown} ${styles.formControl}`}
                  onBlur={formik.handleBlur}
                />
              </div>

              <div className="col-12 md:col-4">
                <div className={styles.formLabelContainer}>
                  <label htmlFor="orderDateFrom">
                    <span className={styles.formLabel}>Select Date Range</span>
                  </label>
                </div>

                {/* Flex container for two calendars */}
                <div className="flex gap-2">
                  {/* Start Date */}
                  <div className="flex-1">
                    <Calendar
                      id="orderDateFrom"
                      value={formik?.values?.orderDateFrom}
                      onChange={(e) => { formik.setFieldTouched("orderDateFrom", true); formik.setFieldValue("orderDateFrom", e?.value) }}
                      disabled={disableFields}
                      placeholder="Start Date"
                      maxDate={formik.values?.orderDateTo}
                    />
                    {formik?.touched.orderDateFrom && formik?.errors.orderDateFrom && (
                      <small className="p-error">{formik?.errors.orderDateFrom}</small>
                    )}
                  </div>

                  {/* End Date */}
                  <div className="flex-1">
                    <Calendar
                      id="orderDateTo"
                      value={formik?.values?.orderDateTo}
                      onChange={(e) => { formik.setFieldTouched("orderDateTo", true); formik.setFieldValue("orderDateTo", e?.value) }}
                      disabled={disableFields}
                      placeholder="End Date"
                      minDate={formik.values?.orderDateFrom}
                    />
                    {formik?.touched.orderDateTo && formik?.errors.orderDateTo && (
                      <small className="p-error">{formik?.errors.orderDateTo}</small>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 md:col-4 gap-3" style={{ marginTop: "2.5rem" }}>
                <div className="grid">
                  <div className="col-12 md:col-5 ">
                    <Button
                      label="Search"
                      type="submit"
                      size="medium"
                      className={styles?.primaryBtn}
                    />
                  </div>
                  <div className="col-12 md:col-5 ">
                    <Button
                      label="Reset"
                      type="button"
                      size="medium"
                      onClick={() => {
                        formik.resetForm();
                        formik.setValues({
                          orderDateFrom: new Date(),
                          orderDateTo: new Date(),
                          region: defaultRegion?.length > 0 ? defaultRegion : regions[0]?.region,
                          tradingPartnerName: null,
                        });
                        setSevenElevenOrders([]);
                        setDisableFields(false);
                        fetchSevenElevenOrders({ ...initialValues, region: defaultRegion?.length > 0 ? defaultRegion : regions[0]?.region });
                      }}
                      className={styles?.resetBtn}
                    />
                  </div>
                </div>
                <div className="grid lg:mr-0">
                  <div className="col-12" >
                    <div className={styles.recordLimit}>
                      <span>
                        <i className={`${styles.recordLimit} pi pi-info-circle p-0`} style={{ fontSize: '10px', marginBottom: "0.5rem" }}></i>
                        {" "} Fetching latest 5000 records only
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

        </div>
      </div>

      <div className="mt-4">
        <DataTable
          value={sevenElevenOrders}
          tableStyle={{ minWidth: "50rem" }}
          scrollable
          paginator={constants.paginator}
          first={currentPage}
          rows={currentPageRows}
          onPage={(e) => { setCurrentPage(e.first); setCurrentPageRows(e?.rows) }}
          rowsPerPageOptions={constants.rowsPerPageOptions}
          paginatorTemplate={constants.paginatorTemplate}
          currentPageReportTemplate={constants.currentPageReportTemplate}
          emptyMessage={constants.emptyMessage}
          dataKey="fileCorrelationId"
          scrollHeight="30vw"
          selectionMode="checkbox"
          selection={selectedSevenElevenOrders}
          onSelectionChange={(e) => setSelectedSevenElevenOrders(e.value)}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={rowExpansionTemplate}
        >
          <Column style={{ width: "10px" }} body={orderActionTemplate} />
          <Column
            header={
              <Button
                className={
                  allExpanded ? "pi pi-angle-down" : "pi pi-angle-right"
                }
                style={{
                  fontSize: "1.3rem",
                  color: "#6c757d",
                  backgroundColor: "#f8f9fa",
                  border: "none",
                  padding: "2px"
                }}
                onClick={toggleRows}
              ></Button>
            }
            style={{ width: "10px" }}
            expander={true}
          />
          {sevenElevenOrderColumns.map((col, index) => (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              sortable={col.sort}
              style={{ minWidth: col.minWidth }}
              headerStyle={{ minWidth: col.minWidth }}
              body={col.value || null}
            />
          ))}
        </DataTable>
      </div>

      <Toast ref={toast} position="center" />
      {showReProcessConfirmation && (
        <ConfirmDialog
          visible={showReProcessConfirmation}
          message={`${failedItemsCount}` > 0 ? `Only (${failedItemsCount}/${totalNumberOfFiles}) Sales-Orders will be reprocessed, Not the error records!` : "Are you sure you want to Re-process the records"}
          header="Note"
          icon="pi pi-exclamation-circle"
          style={{ width: "50vw", color: "red" }}
          breakpoints={{ "1100px": "75vw", "960px": "100vw" }}
          accept={() => reprocessItems()}
          onHide={() => setShowReprocesConfirmation(false)}
        ></ConfirmDialog>
      )}
      {proceedWithSuccessConfirmation && (
        <ConfirmDialog
          visible={proceedWithSuccessConfirmation}
          message={`Are you sure you want to proceed with processing the successful records by skipping the error records?`}
          header="Confirm"
          icon="pi pi-question-circle"
          style={{ width: "50vw" }}
          breakpoints={{ "1100px": "75vw", "960px": "100vw" }}
          accept={() => proceedWithSuccessItems()}
          onHide={() => setProceedWithSuccessConfirmation(false)}
        ></ConfirmDialog>
      )}
    </>
  );
  
}
